<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;
    
    export let put_item = async (e) => {
        let item = e.detail;
        
        if (item) {
            // Москитная сетка ZANZAR 240x1400, RAL9010 - цвет профилей, Antipo серая - тип сетки, белый - цвет фурнитуры, Нет - наличие рамы, Нет - вставка, Вниз - щетка
            // Москитная сетка ZANZAR 240x2400, RAL8017 - цвет профилей, Стандарт - тип сетки, белый - цвет фурнитуры, Низ - наличие рамы, Да - вставка, Вниз - щетка

            let words = item.title.split(', ');
            let title = words[0].split(' ');
            let size = title[3].split('x');

            width.set(size[0]);
            height.set(size[1]);

            for (var key in color) {
                if (words[1].includes(key)) {
                    ind2 = key;
                }
            }

            for (var element of types) {
                if (words[2].includes(element)) {
                    ind3 = element;
                }
            }

            for (var element of furnituracolor) {
                if (words[3].includes(element)) {
                    ind4 = element;
                }
            }

            for (var element of rama) {
                if (words[4].includes(element)) {
                    ind5 = element;
                }
            }

            for (var element of vstavka) {
                if (words[5].includes(element)) {
                    ind6 = element;
                }
            }

            for (var element of shetka) {
                if (words[6].includes(element)) {
                    ind7 = element;
                }
            }

            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch(ind2);
            change();
        }
    };


    const color = options.color || {
        'RAL9010': 'Белый RAL9010',
        'RAL8017': 'Коричневый RAL8017',
        'Неокрашенный': 'Неокрашенный',
    };

    const types = options.types || [
        'Стандарт',
        'Antipo серая',
        'Antipo черная',
    ];



    const furnituracolor = options.furnituracolor || [
        'белый',
        'черный',
    ];

    const rama = options.rama || [
        'Да',
        'Нет',
        'Низ',
    ];
    const vstavka = options.vstavka || [
        'Да',
        'Нет',
    ];
    const shetka = options.shetka || [
        'Вниз',
        'Внутрь',
    ];



    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('ZANZAR', '', color);
        let options = await network.fetch_ind('ZANZAR');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '240'),
        height = parameter('height', '400'),
        ind1 =  '', //
        ind2 = 'RAL9010', // цвет профиля
        ind3 = 'Стандарт', // тип сетки
        ind4 = 'белый', // цвет фурнитуры
        ind5 = 'Нет', // рама
        ind6 = 'Нет', // вставка
        ind7 = 'Вниз', // вставка


        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch(ind2);

   /* let
        montage_item,
        montage_price = 1;*/

    const changeInd2 = () => {
        fetchData = fetch(ind2)
    };
    const changeInd3 = () => {
        if (ind3.includes('Antipo')) {
            options.max.height = 1800;
        } else {
            options.max.height = 2500;
        }

        let b = $height;
        $height = 0;
        $height = b;
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'мс-zanzar',
            name: 'Москитная сетка ZANZAR',
            subname: [
                $width + 'x' + $height, ', ',
                ind2, ' - цвет профилей, ', ind3, ' - тип сетки, ', ind4, ' - цвет фурнитуры, ', ind5, ' - наличие рамы, ', ind6, ' - вставка, ', ind7, ' - щетка'
            ].join(''),
            title: [
                'Москитная сетка ZANZAR', ' ', $width + 'x' + $height, ', ',
                ind2, ' - цвет профилей, ', ind3, ' - тип сетки, ', ind4, ' - цвет фурнитуры, ', ind5, ' - наличие рамы, ', ind6, ' - вставка, ', ind7, ' - щетка'
            ].join(''),
            params: {
                ind1: [ind4, ' - цвет фурнитуры, ', ind5, '- наличие рамы, ', ind6, '- вставка, ', ind7, '- щетка'].join(''),
                ind2: ind2,
                ind3: ind3,
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 58
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;


            if (name.includes('короб кассеты')  ) {
                kolvo = ((w - 22)/ 1000).toFixed(3);
            }

            if (name.includes('вал') && name.includes(ind3.toLowerCase())) {

                if (ind3.toLowerCase() == 'стандарт' ) {

                    if (name.includes('1,8') &&  h<=1800 )  {

                        kolvo = ((w - 22)/ 1000).toFixed(3);
                    } else if(name.includes('2,5') &&  h>1800) {

                        kolvo = ((w - 22)/ 1000).toFixed(3);

                    }

                }
                else{


                    kolvo = ((w - 22)/ 1000).toFixed(3);
                }

            }

            if (name.includes('подвижный профиль')  ) {
                kolvo = ((w - 83)/ 1000).toFixed(3);
            }

            if (name.includes('направляющая')) {
                kolvo = ((h - 52) * 2 / 1000).toFixed(3);
            }

            if (name.includes('комплект сборочный') && name.includes(ind4.toLowerCase())) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('вставка в трубу')&& ind6 =='Да') {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('щетка уплотнительная черная 6х11мм')) {
                kolvo = ((h * 2)/ 1000).toFixed(3);
            }

            if (name.includes('щетка уплотнительная черная 6х15мм')) {
                kolvo = ((w - 63)/ 1000).toFixed(3);
            }
            if (name.includes('щетка антиветровая')  ) {
                kolvo = ((h - 52) * 2 / 1000).toFixed(3);
            }

            if (name.includes('профиль доборный') && ind5 =='Да') {
                kolvo = (((h - 45) * 2 + (w - 45) * 2)/ 1000).toFixed(3);
            }
            if (name.includes('профиль доборный') && ind5 =='Низ') {
                kolvo = ((  (w - 45) )/ 1000).toFixed(3);
            }
            if (name.includes('уголок доборный')  && ind5 =='Да') {
                kolvo = (4).toFixed(3);
            }
            if (name.includes('уголок доборный')  && ind5 =='Низ') {
                kolvo = (2).toFixed(3);
            }

            if (name.includes('работа')) {
                kolvo = 1;
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

          /*  if (name.includes('монтаж')) {
                montage_item = item;
            }*/
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        /*let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
        dispatch('mounting', {item: montage_item, price: montage_price});*/


        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-6">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">200 ≥ Шир., мм ≥ { options.recomend && options.recomend.width ? options.recomend.width : 6000 }</label>
                                <input type="number"
                                       class="form-control text-center { $width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) ? 'text-danger' : '' }"
                                       step="10"
                                       min="200"
                                       max={ options.max && options.max.width ? options.max.width : 6000 }
                                       bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">200 ≥ Выс., мм ≥ { options.recomend && options.recomend.height ? options.recomend.height : 3000 }</label>
                                <input type="number"
                                       class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 3000) ? 'text-danger' : '' }"
                                       step="10"
                                       min="200"
                                       max={ options.max && options.max.height ? options.max.height : 3000 }
                                       bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет профиля</label>
                                <select class="form-control form-select" bind:value={ind2}  on:change={() => {changeInd2(); change()}} >
                                    {#each Object.entries(color) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                 </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип сетки</label>
                                <select class="form-control form-select" bind:value={ind3} on:change={changeInd3}>
                                   {#each types  as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет фурнитуры</label>
                                <select class="form-control form-select" bind:value={ind4}>
                                    {#each furnituracolor as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Рама доборная</label>
                                <select class="form-control form-select" bind:value={ind5}>
                                    {#each rama as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Вставка в трубу</label>
                                <select class="form-control form-select" bind:value={ind6}>
                                    {#each vstavka as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Щетка</label>
                                <select class="form-control form-select" bind:value={ind7}>
                                    {#each shetka as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="col-12 col-sm-6 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 300px" class="img-fluid p-3" src="/img/zanzar.jpg"/>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}


